import s from "./QuizStart.module.scss";
import { useQuizModalStore } from "@/zustand/quizModalStore";

const base = window.post_template.checkout_v4_quiz;
const headingLabel = base?.tr_quiz_settings_take_a_quiz_label;
const headingSpan = base?.tr_quiz_settings_take_a_quiz_span_label;
const noThanksLabel = base?.tr_quiz_settings_no_thanks_button_label;
const takeQuizLabel = base?.tr_quiz_settings_take_a_quiz_button_label;
const disclaimerText = base?.tr_quiz_settings_disclaimer_text;

const QuizStart = ({ onNext }) => {
  const { closeQuizModal, setQuizCompleted } = useQuizModalStore();

  return (
    <section className={s["quiz-start"]}>
      <div className={s["quiz-start__container"]}>
        <h4 className={s["quiz-start__container--heading"]}>
          {headingLabel}
          <span className={s["quiz-start__container--span"]}> {headingSpan}</span>
        </h4>
      </div>
      <div className={s["quiz-start__buttons"]}>
        <button
          onClick={() => {
            setQuizCompleted(true);
            closeQuizModal();
          }}
          className={s["quiz-start__buttons--primary"]}
        >
          {noThanksLabel}
        </button>
        <button onClick={onNext} className={s["quiz-start__buttons--secondary"]}>
          {takeQuizLabel}
        </button>
      </div>
      <div className={s["quiz-start__disclaimer"]}>
        <p className={s["quiz-start__disclaimer--text"]}>{disclaimerText}</p>
      </div>
    </section>
  );
};

export default QuizStart;
